import {Suspense} from "react";
import {Box, Flex, Stack} from "@chakra-ui/react";
import Sidebar from "./sidebar";
import MobilePricingNav from "./topbar";

type Props = {children: React.ReactNode};

const PricingLayout = (props: Props) => {
  const {children} = props;

  return (
    <Flex id="pricing" direction={{base: "column", md: "row"}}>
      <Box flexShrink={0} display={{base: "none", md: "block"}} pl={2}>
        <Suspense>
          <Sidebar />
        </Suspense>
      </Box>
      <Box display={{md: "none"}} position={"sticky"} top={"93px"} zIndex={99}>
        <MobilePricingNav />
      </Box>
      <Stack pl={{md: 2, lg: 4, "2xl": 6}} overflowX={"auto"} w="100%" spacing={4}>
        {children}
      </Stack>
    </Flex>
  );
};

export default PricingLayout;
